// src/data/orientationCards.js

// CATEGORY_TILE_PNG - Complete mapping of ALL categories to PNG tiles
// Single source of truth: Browse tiles
// NO SVGs. NO new art. NO placeholders.
export const CATEGORY_TILE_PNG = {
  circles: "/images/tiles/tile_circles.png",
  nourish: "/images/tiles/tile_nourish.png",
  sports: "/images/tiles/tile_sports.png",
  learn: "/images/tiles/tile_learn.png",
  culture: "/images/tiles/tile_culture.png",
  home: "/images/tiles/tile_home.png",
  explore: "/images/tiles/tile_explore.png",
};

// All categories for random selection
export const ALL_CATEGORIES = Object.keys(CATEGORY_TILE_PNG);

export const ORIENTATION_CARDS = [
  // --- Circles (Privacy focus) ---
  { id: "C1", headline: "Your circle controls visibility.", body: "Only people you choose see what you share.", category: "circles" },
  { id: "C2", headline: "Friends, not followers.", body: "No audience here.", category: "circles" },
  { id: "C3", headline: "You choose who sees you.", body: "Always.", category: "circles" },

  // --- Nourish & Care ---
  { id: "N1", headline: "Care without performance.", body: "No one is watching.", category: "nourish" },
  { id: "N2", headline: "Small moments matter.", body: "Not everything needs to be shared.", category: "nourish" },
  { id: "N3", headline: "Presence over perfection.", body: "Just being there counts.", category: "nourish" },

  // --- Sports & Movement ---
  { id: "S1", headline: "Movement connects people.", body: "Competition optional. Presence required.", category: "sports" },
  { id: "S2", headline: "It's okay to go slow.", body: "Walking counts.", category: "sports" },
  { id: "S3", headline: "Play without scoreboards.", body: "Enjoyment comes first.", category: "sports" },

  // --- Learn & Create ---
  { id: "L1", headline: "Quiet is welcome.", body: "Silence counts as participation.", category: "learn" },
  { id: "L2", headline: "You don't need to share everything.", body: "Some moments stay small.", category: "learn" },
  { id: "L3", headline: "Attention stays with the moment.", body: "Not the reaction.", category: "learn" },

  // --- Culture & Play ---
  { id: "CU1", headline: "Quiet on purpose.", body: "No pressure. No metrics. No audience.", category: "culture" },
  { id: "CU2", headline: "Calm is a feature.", body: "Not an absence.", category: "culture" },
  { id: "CU3", headline: "You don't have to be good.", body: "You just have to show up.", category: "culture" },

  // --- Home & Life Systems ---
  { id: "H1", headline: "Everyday moments count.", body: "No special occasion needed.", category: "home" },
  { id: "H2", headline: "Shared time matters.", body: "Even when nothing special happens.", category: "home" },
  { id: "H3", headline: "Safety is built in.", body: "Not added later.", category: "home" },

  // --- Connect & Explore ---
  { id: "E1", headline: "Activities come first.", body: "The point isn't posting. It's doing.", category: "explore" },
  { id: "E2", headline: "Nothing to perform.", body: "Be there. That's enough.", category: "explore" },
  { id: "E3", headline: "You decide when to add.", body: "There's no rush here.", category: "explore" },
];

/**
 * Pick 3 cards with NO DUPLICATE TILES in the same session.
 * Each card uses a different category PNG.
 */
export function pickSessionCards(count = 3) {
  // Shuffle all categories
  const shuffledCategories = [...ALL_CATEGORIES].sort(() => Math.random() - 0.5);
  
  // Take first `count` categories (ensures no duplicate tiles)
  const selectedCategories = shuffledCategories.slice(0, count);
  
  // For each selected category, pick one random card from that category
  const result = selectedCategories.map(category => {
    const categoryCards = ORIENTATION_CARDS.filter(c => c.category === category);
    const randomIndex = Math.floor(Math.random() * categoryCards.length);
    return categoryCards[randomIndex];
  });
  
  return result;
}
